import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue') },
  { path: '/', name: 'Layout', component: () => import('../layout/Layout.vue'),
    redirect: '/home',
    children: [
      { path: 'home', name: 'Home', component: () => import('../views/Home.vue') },
      { path: 'meeting', name: 'Meeting', component: () => import('../views/meeting/MeetingList.vue') },
      { path: 'seat', name: 'Seat', component: () => import('../views/seat/SeatList.vue') },
      { path: 'banquet', name: 'Banquet', component: () => import('../views/banquet/BanquetList.vue') },
      { path: 'checkin', name: 'Checkin', component: () => import('../views/checkin/CheckinList.vue') },
      { path: 'lottery', name: 'Lottery', component: () => import('../views/lottery/LotteryManage.vue') },
      { path: 'change-password', name: 'ChangePassword', component: () => import('../views/ChangePassword.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
